/**
 * Load More Posts functionality
 * Handles AJAX loading of blog posts with pagination
 */

document.addEventListener('DOMContentLoaded', function () {
    const loadMoreBtn = document.getElementById('load-more-posts');

    if (!loadMoreBtn) {
        return; // Exit if button doesn't exist on page
    }

    const postsContainer = document.getElementById('posts-container');

    if (!postsContainer) {
        console.error('Posts container not found');
        return;
    }

    // Check if loadMorePosts object exists (localized from PHP)
    if (typeof loadMorePosts === 'undefined') {
        console.error('loadMorePosts object not found. Make sure wp_localize_script is called.');
        return;
    }

    loadMoreBtn.addEventListener('click', function () {
        const button = this;
        const currentPage = parseInt(button.getAttribute('data-page'));
        const totalPages = parseInt(button.getAttribute('data-total-pages'));
        const postsPerPage = parseInt(button.getAttribute('data-posts-per-page'));
        const postType = button.getAttribute('data-post-type') || 'post';
        const includedCategories = button.getAttribute('data-included-categories');
        const excludedCategories = button.getAttribute('data-excluded-categories');
        const nextPage = currentPage + 1;

        // Disable button and show loading state
        button.disabled = true;
        button.classList.add('loading');
        button.querySelector('.load-more-text').style.display = 'none';
        button.querySelector('.load-more-spinner').style.display = 'inline-block';

        // Prepare AJAX request
        const formData = new FormData();
        formData.append('action', 'load_more_posts');
        formData.append('nonce', loadMorePosts.nonce);
        formData.append('page', nextPage);
        formData.append('posts_per_page', postsPerPage);
        formData.append('post_type', postType);

        // Add category filters if they exist
        if (includedCategories) {
            formData.append('included_categories', includedCategories);
        }
        if (excludedCategories) {
            formData.append('excluded_categories', excludedCategories);
        }

        // Make AJAX request
        fetch(loadMorePosts.ajaxurl, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin'
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(data => {
            if (data.success && data.data) {
                const responseData = data.data;

                // Create a temporary container to parse HTML
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = responseData.html;

                // Get all new post items
                const newPosts = tempDiv.querySelectorAll('.post-item');

                // Append new posts with fade-in animation
                newPosts.forEach((post, index) => {
                    post.style.opacity = '0';
                    post.style.transform = 'translateY(20px)';
                    post.style.transition = 'opacity 0.5s ease, transform 0.5s ease';

                    postsContainer.appendChild(post);

                    // Trigger animation with slight delay for stagger effect
                    setTimeout(() => {
                        post.style.opacity = '1';
                        post.style.transform = 'translateY(0)';
                    }, index * 100);
                });

                // Update button data attributes
                button.setAttribute('data-page', responseData.current_page);
                button.setAttribute('data-total-pages', responseData.total_pages);

                // Hide button if no more posts
                if (!responseData.has_more) {
                    button.parentElement.style.display = 'none';
                } else {
                    // Re-enable button
                    button.disabled = false;
                    button.classList.remove('loading');
                    button.querySelector('.load-more-text').style.display = 'inline';
                    button.querySelector('.load-more-spinner').style.display = 'none';
                }
            } else {
                throw new Error('Invalid response from server');
            }
        })
        .catch(error => {
            console.error('Error loading more posts:', error);

            // Show error message
            const errorMsg = document.createElement('p');
            errorMsg.className = 'load-more-error';
            errorMsg.textContent = 'Error loading posts. Please try again.';
            errorMsg.style.color = '#d32f2f';
            errorMsg.style.textAlign = 'center';
            errorMsg.style.marginTop = '1rem';

            button.parentElement.appendChild(errorMsg);

            // Remove error message after 5 seconds
            setTimeout(() => {
                errorMsg.remove();
            }, 5000);

            // Re-enable button
            button.disabled = false;
            button.classList.remove('loading');
            button.querySelector('.load-more-text').style.display = 'inline';
            button.querySelector('.load-more-spinner').style.display = 'none';
        });
    });
});
